import { t, lang, locale, setGlobal } from "@/i18n";

export const CURRENCIES = ["EUR", "USD", "GBP", "CHF", "CAD", "AUD"];
let currency = "EUR";
let fmt = {};
export const setCurrency = (c) => {
  if (CURRENCIES.includes(c) && c !== currency) { currency = c; fmt = {}; }
  setGlobal("cur", currencySymbol());
};
const money = (digits) => (fmt[digits] ||= new Intl.NumberFormat(locale, { style: "currency", currency, maximumFractionDigits: digits }));

// Names kept for compatibility: amounts use the restaurant currency (EUR by default).
export const eur = (v) => money(2).format(Number(v) || 0);
export const eur0 = (v) => money(0).format(Number(v) || 0);
export const eurUnit = (v) => money(3).format(Number(v) || 0);
export const currencySymbol = () => money(2).formatToParts(0).find((p) => p.type === "currency")?.value || currency;
export const pct = (v, signed = false) => {
  const n = Number(v) || 0;
  const s = n.toLocaleString(locale, { maximumFractionDigits: 1, minimumFractionDigits: 1 });
  return `${signed && n > 0 ? "+" : ""}${s}${lang === "fr" ? " %" : "%"}`;
};
export const pctInt = (v) => `${v}${lang === "fr" ? " %" : "%"}`;
export const num = (v) => (Number(v) || 0).toLocaleString(locale, { maximumFractionDigits: 3 });
export const dateFr = (v) => (v ? new Date(v).toLocaleDateString(locale, { day: "2-digit", month: "short", year: "numeric" }) : "—");
export const unitLabel = (u) => (u === "pièce" ? t("common.unit_piece") : u);

export const fold = (s) => (s || "").toLowerCase().replace(/œ/g, "oe").replace(/æ/g, "ae").normalize("NFD").replace(/[\u0300-\u036f]/g, "");

export const severityOf = (p) => (p > 15 ? "red" : p >= 5 ? "orange" : "green");

export const foodCostTone = (fc, target = 30) =>
  fc <= target ? "text-emerald-600 dark:text-emerald-400" : fc <= target + 5 ? "text-amber-600 dark:text-amber-400" : "text-rose-600 dark:text-rose-400";

const UNITS = { kg: ["m", 1000], g: ["m", 1], L: ["v", 1000], cl: ["v", 10], ml: ["v", 1], "pièce": ["u", 1] };
export const UNIT_OPTIONS = ["g", "kg", "ml", "cl", "L", "pièce"];
export const BUY_UNITS = ["kg", "L", "pièce"];
export const CATEGORIES = ["Viande", "Poisson", "Légumes", "Fruits", "Produits laitiers", "Épicerie", "Boulangerie", "Boissons", "Autre"];
export const RECIPE_CATEGORIES = ["Entrées", "Plats", "Desserts", "Boissons", "Accompagnements"];
// Category values are stored in French; only their label is translated.
const CAT_KEYS = { Viande: "format.viande", Poisson: "format.poisson", "Légumes": "format.legumes", Fruits: "format.fruits",
  "Produits laitiers": "format.produits_laitiers", "Épicerie": "format.epicerie", Boulangerie: "format.boulangerie",
  Boissons: "format.boissons", Autre: "common.autre", "Entrées": "common.entrees", Plats: "common.plats", Desserts: "common.desserts",
  Accompagnements: "format.accompagnements" };
export const catLabel = (c) => (CAT_KEYS[c] ? t(CAT_KEYS[c]) : c);

export function convertQty(q, from, to) {
  const a = UNITS[from], b = UNITS[to];
  if (!a || !b || a[0] !== b[0]) return q;
  return (q * a[1]) / b[1];
}

export const compatibleUnits = (u) => {
  const d = UNITS[u]?.[0];
  return d ? UNIT_OPTIONS.filter((x) => UNITS[x][0] === d) : UNIT_OPTIONS;
};
